import type { EventType } from "app/types/eventType";
import React, { lazy, Suspense } from "react";
import { FormattedMessage } from "react-intl";
const EventMarketPeriodSummarized: React.LazyExoticComponent<any> = lazy(
  () =>
    import(
      "../../../../screens/EventDetailScreen/components/EventMarketPeriodSummarized/EventMarketPeriodSummarized"
    )
);
//
type Props = {
  data: EventType;
  toggleAlternativeLines: (...args: Array<any>) => any;
  noOddsMessage: any;
  isOutright: boolean;
};

const PopularEventCellMarkets: React.FC<Props> = props => {
  const { data, toggleAlternativeLines, noOddsMessage, isOutright } = props;
  const hasMarketPeriods =
    data && data.marketPeriods && data.marketPeriods.length > 0;

  return (
    <div className="popular-event-cell__markets">
      {hasMarketPeriods && !isOutright ? (
        data != null &&
        data.marketPeriods != null &&
        data.marketPeriods.map((marketPeriod, index) => {
          // replace index with unique identifier
          return (
            <Suspense
              key={`key-${index}`}
              fallback={<div className="fallback">loading...</div>}
            >
              <EventMarketPeriodSummarized
                marketPeriod={marketPeriod}
                event={data}
                key={index}
                onClick={toggleAlternativeLines}
              />
            </Suspense>
          );
        })
      ) : (
        <div className="no-odds-available">
          <FormattedMessage tagName="span" id={noOddsMessage} />
        </div>
      )}
    </div>
  );
};

export default PopularEventCellMarkets;
